import { render, staticRenderFns } from "./codification-lean.vue?vue&type=template&id=57c45366"
import script from "./codification-lean.vue?vue&type=script&lang=js"
export * from "./codification-lean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports